// extracted by mini-css-extract-plugin
module.exports = {"block":"HTMLBlock_block__79L64"};